<template>
  <div class="center-container">
    <div class="head">
      <div class="text">{{ pageTitle }}</div>
    </div>
    <div class="paging-box">
      <div class="paging">
        <div
          v-for="(item, index) in categories"
          :key="index"
          class="paging-item"
          :class="item.active ? 'paging-item-active' : ''"
          @click="setActivePaging(index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="course-list">
      <div v-if="filterList.length === 0" class="no-list">
        <span>{{ tips }}</span>
      </div>
      <div
        v-for="(item, index) in filterList"
        v-show="item.has_courses !== '' && (!item.hideMineCourse || !item.hideMineExam)"
        :key="index"
        class="course-item"
      >
        <div class="course-item__left">
          <img class="course-item-img" :src="item.pic" />
        </div>

        <div class="course-item__right">
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <div
              v-if="
                !item.hideMineCourse &&
                (item.has_courses == '1' || item.has_courses == '1,2')
              "
              class="content-item divider"
              @click="goOnlineCourse(item)"
            >
              <span class="content-item-main">
                <i class="material-icons">movie</i>
                在线课程
              </span>
            </div>
            <div
              v-if="
                !item.hideMineExam &&
                (item.has_courses == '2' || item.has_courses == '1,2')
              "
              class="content-item"
              :class="{ disabled: item.allow_practise === 0 }"
              @click="goModuleExam(item)"
            >
              <span class="content-item-main">
                <i class="material-icons">description</i>
                章节练习
              </span>
            </div>
            <div
              v-if="
                !item.hideMineExam &&
                (item.has_courses == '2' || item.has_courses == '1,2')
              "
              class="content-item divider"
              :class="{ disabled: item.allow_practise === 0 }"
              @click="goMockExam(item)"
            >
              <span class="content-item-main">
                <i class="material-icons">description</i>
                模拟考试
              </span>
            </div>
            <div
              v-if="item.project_id > 0"
              class="content-item divider"
              @click="goFinalExam(item)"
            >
              <span class="content-item-main">
                <i class="material-icons">description</i>
                结业考试
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCourseCenter, UserGetSubjectCategories } from "@/api/index";
export default {
  name: "Center",
  components: {},
  data() {
    return {
      list: [],
      tips: "",
      categories: [],
    };
  },
  computed: {
    pageTitle() {
      return "我的课程";
    },
    filterList() {
      let result = [];
      result = this.list.map((item) => {
        item.hideMineCourse = item.isVisible === 0;
        if (item.has_courses == "2") {
          item.hideMineCourse = true;
        }
        item.hideMineExam = item.allow_practise === 0;
        if (item.has_courses == "1") {
          item.hideMineExam = true;
        }
        return item;
      });
      return result;
    },
  },
  watch: {},
  created() {
    this.getSubjectCategories();
  },
  methods: {
    goOnlineCourse(item) {
      this.routePush(item, "/course-chapter-lists?type=1");
    },
    goModuleExam(item) {
      if (this.$courseExamHaveToPay(item)) return;
      this.routePush(item, "/course-chapter-lists?type=2");
    },
    goMockExam(item) {
      if (this.$courseExamHaveToPay(item)) return;
      this.routePush(item, "/mock-exam");
    },
    goFinalExam(item) {
      this.routePush(item, "/final-exam?type=1");
    },
    routePush(item, path) {
      const routeObj = {
        path: path,
        query: {
          subject_id: item.id,
          is_visible: item.isVisible,
          allow_practise: item.allow_practise,
          project_id: item.project_id,
          is_record: this.$route.query.is_record,
        },
      };

      this.$router.push(routeObj);
    },

    async getSubjectCategories() {
      const data = await UserGetSubjectCategories();
      this.categories = data.map((item) => {
        item.active = false;
        return item;
      });
      this.setActivePaging();
    },

    setActivePaging(page = 0) {
      this.categories.map((item, index) => {
        item.active = page === index;
        return item;
      });
      this.fetchData(this.categories[page].id);
    },

    async fetchData(id) {
      const params = {};
      if (id > -1) params.category_id = id;
      try {
        const data = await fetchCourseCenter(params);
        this.list = data;
        console.log(data);
        if (data.length === 0) {
          this.tips = "暂无课程，请去课程中心购买或报名";
        }
      } catch ($e) {
        this.tips = "暂无课程，请去课程中心购买或报名";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center-container {
  background: #f7f7f9;
  height: 100vh;
}
.head {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  background-color: #214ecf;
  color: #fff;
  text-align: center;
}
.no-list {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.paging-box {
  padding: 0 14px;

  .paging {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
    margin-top: 8px;
    overflow-x: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      color: transparent;
    }
    .paging-item {
      padding: 2px 8px;
      color: #214ecf;
      border: 1px solid #214ecf;
      border-radius: 6px;
      margin-right: 8px;
    }
    .paging-item-active {
      background: #214ecf;
      color: #fff;
      font-weight: 600;
    }
  }
}
.course-list {
  padding: 0 20px;
  color: #333;
  .course-item {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    // border-bottom: 1px solid #ddd;
    background: #fff;
    margin-top: 16px;
    box-shadow: 0 0 6px 2px #ddd;
    border-radius: 8px;
    overflow: hidden;
    padding: 16px 12px;
    .course-item__left {
      margin-right: 12px;
      display: flex;
      align-items: center;
      .course-item-img {
        width: 72px;
      }
    }

    .course-item__right {
      display: flex;
      flex-flow: column;
      flex: 1;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      color: #000;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      .content-item {
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: left;
        flex-basis: 50%;
        background: #fff;
        margin-bottom: 8px;
        position: relative;
        color: #333;

        .content-item-main {
          display: flex;
          align-items: center;
          height: 15px;
          flex: 1;
          justify-content: flex-start;
          i {
            margin-right: 5px;
          }
        }

        &.disabled {
          color: #ccc;
        }

        // &:nth-of-type(2n-1) > .content-item-main {
        //   border-right: 1px solid #aaa;
        // }

        // &:last-of-type > .content-item-main {
        //   border-right: none;
        // }

        .material-icons {
          font-size: 16px;
          color: #5687fa;
        }
      }
    }
  }
}
</style>
